import { EXERCISE_OP_ALPHA_PROXIMITY_THREAT_VESSEL_ID } from '../data/realisticExerciseScenarioData';
import { isAutonomousUnderwaterVehicleCategory } from './demoAuvRasterVessel';

/** Vessel that should use demo threat/missile raster (must match live `unique_identifier`). */
export const DEMO_THREAT_MISSILE_VESSEL_UUID = EXERCISE_OP_ALPHA_PROXIMITY_THREAT_VESSEL_ID;

function normalizeVesselCategoryKey(obj) {
  return String(
    obj?.common_name ??
      obj?.message_description_label ??
      obj?.message_description_name ??
      obj?.object_classification ??
      ''
  )
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
}

/** e.g. "Unknown Surface Usv" → unknown_surface_usv */
export function isUnknownSurfaceUsvVessel(obj) {
  const key = normalizeVesselCategoryKey(obj);
  if (!key) return false;
  if (key === 'unknown_surface_usv') return true;
  return key.includes('unknown') && key.includes('surface') && key.includes('usv');
}

function normalizeVesselUuid(obj) {
  return String(obj?.unique_identifier ?? obj?.id ?? '').trim().toLowerCase();
}

/**
 * Threat icon (icon-threat.png) only for the designated unknown-surface USV when status is threat.
 * Vessel ID: 436554c6-a314-478c-8ebc-6df48780d1fa
 */
export function isDemoThreatMissileVessel(obj) {
  if (!obj) return false;
  if (isAutonomousUnderwaterVehicleCategory(obj)) return false;
  if (normalizeVesselUuid(obj) !== DEMO_THREAT_MISSILE_VESSEL_UUID.toLowerCase()) return false;
  const flagged = obj.threat_detected === 'Yes' || obj.threat_detected === true;
  if (!flagged) return false;
  return isUnknownSurfaceUsvVessel(obj);
}
